import { render, staticRenderFns } from "./FontSize.vue?vue&type=template&id=e41aa7ce&scoped=true"
import script from "./FontSize.vue?vue&type=script&lang=js"
export * from "./FontSize.vue?vue&type=script&lang=js"
import style0 from "./FontSize.vue?vue&type=style&index=0&id=e41aa7ce&prod&lang=scss"
import style1 from "./FontSize.vue?vue&type=style&index=1&id=e41aa7ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41aa7ce",
  null
  
)

export default component.exports